import { z } from 'zod';

const unmetNeedsMetricsSchema = z.object({
  eligiblePatientCount: z.number(),
  criteriaMetPatientCount: z.number(),
  pct: z.number(),
});

const unmetNeedsRecSchema = z.object({
  definition: z.string(),
  eligiblePopulation: z.string(),
  identifier: z.string(),
  name: z.string(),
  metrics: unmetNeedsMetricsSchema.nullable(),
});

export const recommendationReasonSchema = z.object({
  reason: z.string(),
  items: z.array(z.string()),
  unmetNeeds: z.array(unmetNeedsRecSchema),
});
export namespace KolProfile {
  export type Affiliation = {
    // id: number;
    name: string;
    city: string | null;
    state: string | null;
    street: string | null;
    zip: string | null;
    country: string | null;
    role: string | null;
    department: string | null;
  };

  export type Association = {
    // id: number;
    country: string | null;
    name: string;
    type: string;
    jobTitle: string | null;
    positionType: string | null;
    isCurrent: boolean;
  };

  export type ContactDetails = {
    address: string | null;
    email: string | null;
    phone: string | null;
    primaryAffiliation: string | null;
  };

  export type ClinicalTrial = {
    id: number;
    name: string;
    phase: string | null;
    country: string | null;
    role: string | null;
    startDate: Date;
    endDate: Date | null;
  };

  export type CompanySponsorship = {
    id: number;
    companyName: string;
    hasSponsoredClinicalTrial: boolean;
    hasSponsoredEvent: boolean;
    country: string | null;
  };

  export type Collaboration = {
    // id: number;
    collaborationType: string[];
    country: string | null;
    companyName: string;
    relationshipStrength: string | null;
  };

  export type Event = {
    id: number;
    name: string;
    startDate: Date;
    endDate: Date | null;
    eventType: string;
    country: string | null;
    city: string | null;
    position: string | null;
    talkTitle: string | null;
  };

  export type ScientificFocusArea = {
    name: string;
    scoreDecile: number;
    type: string;
  };

  export type ClinicalFocusArea = {
    name: string;
    scoreDecile: number;
    type: string;
  };

  export type DigitalFocusArea = {
    name: string;
    scoreDecile: number;
  };

  export type Publication = {
    id: number;
    title: string;
    authorshipPosition: string;
    journal: string | null;
    link: string | null;
    publicationDate: Date;
    publicationType: string;
    country: string;
  };

  export type RecommendationReason = z.infer<typeof recommendationReasonSchema>;

  export type UnmetNeedsMetrics = z.infer<typeof unmetNeedsMetricsSchema>;

  export type PatientUnmetNeedMetric = {
    unmetNeed: string;
    metrics: UnmetNeedsMetrics | null;
  };

  export type KolToListStaticBadges = Record<string, string> | null;
  export type KolToListDynamicBadges = Record<string, string> | null;
  export type KolToListProfileTextSections = Record<string, string> | null;
  export type KolToListProfileBulletSections = Record<string, string[]> | null;
}
